export default __webpack_public_path__ + "static/media/ojos-normal-marron.4f531bb4.png";